import { render, staticRenderFns } from "./ProgramsSingleGraduatesCoordinator.vue?vue&type=template&id=ce970ed8&"
import script from "./ProgramsSingleGraduatesCoordinator.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleGraduatesCoordinator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports